<template>
  <v-container class="pt-0">
    <v-row
      ><v-col class="mx-0 px-0 pt-0">
        <header-text-bg
          :site="site"
          text="warranty"
          :redirect_name="redirect_name"
          :hide_back="inBottomNavbar"
        />
      </v-col>
    </v-row>

    <!-- ========== ========== Register Now ========== ========== -->
    <v-row v-if="listProduct.length > 0" class="mt-3 mb-1">
      <v-col class="d-flex py-0 px-5" cols="12">
        <div
          class="pa-4"
          style="width: 100%; border-radius: 16px"
          :style="{
            'background-color': '#0f4c81',
            color: '#ffffff',
          }"
        >
          <div style="font-weight: 600; font-size: 20px">
            {{ $t("newProductWarranty") }} ?
          </div>
          <div class="mb-6" style="font-size: 16px; line-height: 1.2">
            {{ $t("registerWarrantyDescription") }}
          </div>
          <v-btn
            class="text-none"
            small
            elevation="0"
            color="#f49f1c"
            style="padding: 24px; border-radius: 8px"
            @click="onClickNew"
          >
            <p
              class="d-flex align-center ma-1 text-end text-subtitle-1 font-weight-bold"
              :style="{
                color: '#000000',
              }"
            >
              <v-icon class="mr-2" color="#000000"
                >mdi-plus-circle-outline</v-icon
              >
              {{ $t("registerNow") }}
            </p>
          </v-btn>
        </div>
      </v-col>
    </v-row>

    <!-- ========== ========== ========== ========== -->
    <v-row class="mt-3 mb-1">
      <v-col class="d-flex justify-space-between py-0 px-5" cols="12">
        <div style="font-weight: 600; font-size: 20px">
          {{ $t("allWarranty") }}
        </div>
        <v-btn
          class="text-none pl-2 pr-0"
          rounded
          small
          color="grey lighten-5"
          @click="onClickRequestAll"
        >
          <p class="d-flex align-center ma-1 text-end text-subtitle-2">
            {{ $t("allRequest") }}
            <v-icon style="padding-top: 1px">mdi-chevron-right</v-icon>
          </p>
        </v-btn>
      </v-col>
    </v-row>

    <v-row class="mt-3 mb-1">
      <v-col class="d-flex justify-end py-0 px-5" cols="12">
        <v-btn
          class="text-none"
          rounded
          small
          :color="site.color"
          @click="dialogFilter = true"
        >
          <p
            class="d-flex align-center ma-1 text-end text-subtitle-2"
            :style="{
              color: setColorFilter(),
            }"
          >
            <v-icon :color="setColorFilter()">mdi-sort-variant</v-icon>
            {{ $t("textFilter") }}
          </p>
        </v-btn>
      </v-col>
    </v-row>

    <!-- ========== ========== Data ========== ========== -->
    <v-row class="px-2 mt-2" style="padding-bottom: 80px">
      <v-col
        v-for="(item, index) in listData"
        :key="index"
        cols="12"
        class="py-1 mt-1"
      >
        <v-sheet rounded>
          <v-card
            elevation="2"
            rounded="lg"
            style="background-color: #ffffff"
            @click="onClickCard(item)"
          >
            <v-card-title class="py-2 px-2">
              <v-container>
                <v-row>
                  <v-col cols="12" class="pa-1">
                    <div class="d-flex" style="gap: 14px; z-index: 1">
                      <div class="d-flex align-center" style="min-width: 64px">
                        <div
                          class="d-flex align-center justify-center"
                          style="
                            width: 64px;
                            height: 64px;
                            border-radius: 8px;
                            overflow: hidden;
                          "
                          :style="{
                            background: setBackgoundColorImage(),
                          }"
                        >
                          <v-img
                            v-if="
                              item.product_image &&
                              item.product_image.length > 0
                            "
                            :src="item.product_image[0]"
                            style="
                              width: 100%;
                              height: 100%;
                              object-fit: contain;
                            "
                            @error="onImageError(item, 'product_image', 0)"
                          >
                          </v-img>
                          <v-icon
                            v-else
                            :color="getFontColorBasedOnBg()"
                            size="40"
                            >mdi-package-variant-closed</v-icon
                          >
                        </div>
                      </div>
                      <div class="d-flex flex-column" style="width: 100%">
                        <div
                          class="d-flex align-center justify-space-between"
                          style="gap: 4px"
                        >
                          <p
                            class="description-label title-card text-start mb-0 pb-0 text-subtitle-1 font-weight-bold"
                            style="max-height: 42px"
                          >
                            {{ item.product_name }}
                          </p>
                          <div v-if="item.status" class="d-flex justify-end">
                            <v-chip
                              class="font-weight-bold"
                              :style="{
                                'background-color': chipStatus(
                                  item.current_status
                                ).bg,
                                color: chipStatus(item.current_status).font,
                              }"
                              dark
                              small
                            >
                              {{ $t(`warrantyStatus.${item.current_status}`) }}
                            </v-chip>
                          </div>
                        </div>
                        <p
                          class="description-label-1 title-card text-start mb-0 pb-0 text-subtitle-2 grey--text text--darken-1 pt-1"
                        >
                          {{ item.serial_number }}
                        </p>
                        <div class="d-flex align-center" style="gap: 4px">
                          <div
                            style="
                              color: #757575;
                              font-size: 14px;
                              line-height: 1;
                            "
                          >
                            {{ $t("expiredAt2") }} :
                          </div>
                          <v-icon
                            small
                            :color="item.is_expired ? '#f44336' : '#757575'"
                            >mdi-calendar</v-icon
                          >
                          <div
                            style="font-size: 14px; line-height: 1"
                            :style="{
                              color: item.is_expired ? '#f44336' : '#757575',
                            }"
                          >
                            {{ item.expired_at | formatDate }}
                          </div>
                          <v-chip
                            v-if="item.is_expired"
                            class="font-weight-bold"
                            :style="{
                              'background-color': chipStatus(item.status).bg,
                              color: chipStatus(item.status).font,
                            }"
                            dark
                            small
                          >
                            {{ $t(`warrantyStatus.${item.status}`) }}
                          </v-chip>
                        </div>
                      </div>
                    </div>
                    <v-divider class="my-2"></v-divider>

                    <!-- ========== ========== Bottom ========== ========== -->
                    <div
                      class="d-flex"
                      style="width: 100%; height: 28px; gap: 4px"
                    >
                      <div
                        class="d-flex align-center pa-2 pl-0"
                        style="gap: 8px"
                        :style="{
                          cursor: ['pending', 'rejected'].includes(
                            item.current_status
                          )
                            ? 'default'
                            : 'pointer',
                        }"
                        @click="onClickRequest($event, item)"
                      >
                        <div v-if="item.is_notification">
                          <div
                            class="d-flex align-center justify-center"
                            style="
                              height: 28px;
                              background-color: #f44336;
                              color: #ffffff;
                              border-radius: 8px;
                              font-size: 12px;
                              padding: 0px 8px;
                            "
                          >
                            <div>
                              {{
                                item.notification_count > 10
                                  ? 10
                                  : item.notification_count
                              }}
                            </div>
                            <div v-if="item.notification_count > 10">+</div>
                          </div>
                        </div>
                        <div
                          :style="{
                            color: ['pending', 'rejected'].includes(
                              item.current_status
                            )
                              ? '#9E9E9E'
                              : '#0f4c81',
                          }"
                          style="font-size: 14px"
                        >
                          {{ $t("serviceRequest") }}
                        </div>
                        <v-icon
                          small
                          :color="
                            ['pending', 'rejected'].includes(
                              item.current_status
                            )
                              ? '#9E9E9E'
                              : '#0f4c81'
                          "
                          >mdi-arrow-right</v-icon
                        >
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-title>
          </v-card>
        </v-sheet>
      </v-col>
    </v-row>

    <div>
      <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler">
        <div slot="spinner"></div>
        <div slot="no-more"></div>
        <div slot="no-results"></div>
      </infinite-loading>
    </div>

    <div v-if="!listData.length">
      <v-col class="d-flex justify-center mt-16">
        <v-img
          class="white--text mx-auto mt-10 empty"
          :src="require('@/assets/images/out-of-stock.png')"
          max-width="150px"
        >
        </v-img>
      </v-col>
      <p class="text-center">{{ $t("errDataNotFound") }}</p>
    </div>

    <WarrantyFilter
      :dialog="dialogFilter"
      :forCreatedBy="forCreatedBy"
      @onClose="dialogFilter = false"
      @onSubmit="onClickSubmitFilter"
    />

    <div
      class="fab-container"
      :style="{
        'padding-bottom': showBottomNavbar ? '70px' : '0px',
      }"
    >
      <v-btn
        v-if="checkFloatPanel"
        fab
        dark
        :color="site.color"
        class="mr-6"
        @click="dialogFloatPanel = true"
      >
        <v-icon>mdi-menu</v-icon>
      </v-btn>
    </div>

    <FloatPanel
      :dialog="dialogFloatPanel"
      @onClose="dialogFloatPanel = false"
    />
  </v-container>
</template>

<script>
import InfiniteLoading from "vue-infinite-loading";
import { mapState } from "vuex";
import HeaderTextBg from "../../../components/headerTextBg.vue";
import Axios from "@/config/customer-service";
import moment from "moment";
import {
  adjustHslBrightness,
  getFontColorBasedOnBg,
} from "../../../config/general-function";
import WarrantyFilter from "../../../components/warranty/warranty-filter.vue";
import FloatPanel from "../../../components/floatPanel.vue";

export default {
  inject: ["isAppLoading"],
  emits: ["onClick"],
  components: {
    InfiniteLoading,
    HeaderTextBg,
    WarrantyFilter,
    FloatPanel,
  },

  data() {
    return {
      next_page_url: "",
      infiniteId: +new Date(),
      listData: [],
      dialogFilter: false,
      dialogFloatPanel: false,

      filterBy: "",
      filterValue: "",
      sortBy: "",
      orderBy: "",

      isUserCreate: false,

      listProduct: [],
      listStatus: ["active", "pending", "rejected"],
      forCreatedBy: "employee",

      redirect_name: "main",
    };
  },
  created() {
    this.getListProduct();
  },
  methods: {
    setColorFilter() {
      let _color = getFontColorBasedOnBg(this.site.color, "bw");
      return _color;
    },
    setBackgoundColorImage() {
      const _color = this.site.color || "#0f4c81";
      const lighten = adjustHslBrightness(_color, 20);
      let _style = `linear-gradient(120deg, ${lighten}, ${_color})`;
      return _style;
    },
    getFontColorBasedOnBg() {
      const res = getFontColorBasedOnBg(this.site.color, "bw");
      return res;
    },
    onImageError(item, key, index) {
      if ([null, undefined, ""].includes(index)) {
        item[key] = null;
      } else {
        item[key][index] = null;
        item[key].splice(index, 1);
      }
    },
    chipStatus(param) {
      const color = {
        active: { bg: "#E8F5E9", font: "#4CAF50" },
        pending: { bg: "#FFF3E0", font: "#FF9800" },
        rejected: { bg: "#FFEBEE", font: "#F44336" },
        expired: { bg: "#E8EAF6", font: "#3F51B5" },
      };
      return {
        bg: color[param]?.bg || "#9E9E9E",
        font: color[param]?.font || "#ffffff",
      };
    },

    // ========== ========== ========== ==========
    async getListProduct() {
      try {
        const response = await Axios.get(
          `/warranty-registration/getProductWarrantyForm`
        );
        const dataResponse = response?.data;
        if (dataResponse?.status == "success") {
          const data = dataResponse?.data || [];
          this.listProduct = [...data];
        }
      } catch (err) {
        console.log("getListProduct", err);
      }
    },
    infiniteHandler($state) {
      this.isAppLoading(true);
      Axios.get(`/warranty-registration/getListWarrantyRegistration`, {
        params: {
          page: this.next_page_url,
          filterBy: this.filterBy,
          filterValue: this.filterValue,
          sortBy: this.sortBy,
          orderBy: this.orderBy,
        },
      })
        .then(({ data }) => {
          if (Array.isArray(data?.data?.data)) {
            let has_more = data.data.has_more;
            this.listData = this.listData.concat(data.data.data);
            if (!has_more) {
              $state.complete();
              return;
            }
            this.next_page_url = data.data.next_page_url.split("=")[1];
            $state.loaded();
          } else {
            $state.complete();
          }
        })
        .finally(() => {
          this.isAppLoading(false);
        });
    },

    onClickCard(param) {
      this.$router.push({
        name: `warranty-detail`,
        params: {
          id: param.id,
        },
      });
    },
    onClickRequest(event, param) {
      event.stopPropagation();
      if (["pending", "rejected"].includes(param.current_status)) {
        return;
      }
      this.$router.push({
        name: `request-list`,
        query: {
          warranty_registration_id: param.id,
        },
      });
    },
    onClickSubmitFilter(param) {
      this.filterBy = param.filterBy;
      this.filterValue = param.filterValue;
      this.sortBy = param.sortBy;
      this.orderBy = param.orderBy;
      this.next_page_url = "";
      this.infiniteId += 1;
      this.listData = [];
      this.dialogFilter = false;
    },
    onClickNew() {
      this.$router.push({
        name: `warranty-registration`,
      });
    },
    onClickRequestAll() {
      this.$router.push({
        name: `request-list-warranty-all`,
      });
    },
  },
  computed: {
    ...mapState("defaultSystem", ["site"]),
    inBottomNavbar() {
      let check = false;
      // ========== ========== ========== ==========
      const curRouteName = this.$router.currentRoute.name;
      let listRouteName = [];
      if (
        Array.isArray(this.site?.bottom_nav_bar?.menu) &&
        this.site?.bottom_nav_bar?.menu?.length > 0
      ) {
        const listRouteAllow = this.site?.bottom_nav_bar.menu.map(
          (x) => x.route_allow
        );
        for (let item of listRouteAllow) {
          listRouteName = [...listRouteName, ...item];
        }
      }
      if (listRouteName.length > 0 && listRouteName.includes(curRouteName)) {
        check = true;
      }
      return check;
    },
    showBottomNavbar() {
      let check = false;
      // ========== ========== ========== ==========
      let checkInRoute = true;
      const curRouteName = this.$route.name;
      let listRouteName = [];
      if (
        Array.isArray(this.site?.bottom_nav_bar?.menu) &&
        this.site?.bottom_nav_bar?.menu?.length > 0
      ) {
        const listRouteAllow = this.site?.bottom_nav_bar.menu.map(
          (x) => x.route_allow
        );
        for (let item of listRouteAllow) {
          listRouteName = [...listRouteName, ...item];
        }
      }
      if (listRouteName.length > 0 && !listRouteName.includes(curRouteName)) {
        checkInRoute = false;
      }
      // ========== ========== ========== ==========
      if (this.site.is_use_bottom_nav && checkInRoute) {
        check = true;
      }
      return check;
    },
    checkFloatPanel() {
      let check = false;
      if (this.site.is_use_float_panel) {
        const float_panel_main_menu = this.site.float_panel_main?.menu || [];
        const float_panel_extend_menu =
          this.site.float_panel_extend?.menu || [];
        const model_main_all_open = float_panel_main_menu.find((x) => x.show);
        const model_extend_all_open = float_panel_extend_menu.find(
          (x) => x.show
        );
        if (model_main_all_open || model_extend_all_open) {
          check = true;
        }
      }
      return check;
    },
  },
  watch: {},
  filters: {
    formatDate: function (value) {
      if (!value) return "-";
      return moment(value).format("DD MMM YYYY");
    },
  },
};
</script>

<style scoped>
.description-label {
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.description-label-1 {
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.title-card {
  line-height: 1.3;
}

::v-deep .v-badge__wrapper {
  left: 3px;
  top: 1px;
}
::v-deep .v-badge__badge {
  width: 6px;
  height: 6px;
}

.fab-container {
  position: fixed;
  bottom: 16px;
  right: 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  z-index: 1;
}
</style>
